import classnames from 'classnames2';

import React from 'react';

import { IBaseProps } from '../../utils';

import { Icon } from '../../Icon';

import styles from './Tab.Setting.module.scss';
export interface ITabSettingProps extends IBaseProps {
  activeTabIndex?: number;
  /** Text displayed as tab title */
  label?: string;
  key?: string;
  /** Indicates the order of the tab ib relation to it's siblings */
  index?: number;
  href?: string;
  /** Accepts values "gray" or "white" to set background color of active tabs */
  activeBackgroundColor?: 'gray' | 'white';
  /** Callback function for the tab group */
  onTabClicked?(tabIndexClicked?): void;
}

export const TabSetting: React.FC<ITabSettingProps> = (props) => {
  const isActiveTab = props.activeTabIndex === props.index;
  const isRightOfActiveTab = props.index === props.activeTabIndex + 1;
  const isInactiveTab = !isActiveTab && !isRightOfActiveTab;

  const classes = classnames(props.className, {
    [`${styles.settingsTab}`]: isActiveTab || isInactiveTab,
    [`${styles.settingsTabActive}`]: isActiveTab,
    [`${styles.rightOfActive}`]: isRightOfActiveTab,
    [`${styles.grayBackground}`]: isActiveTab && props.activeBackgroundColor === `gray`,
    [`${styles.whiteBackground}`]: isActiveTab && props.activeBackgroundColor === `white`
  });

  const HTMLElement = props.href && props.href !== '' ? 'a' : 'button';

  return (
    <div role="presentation" className={classnames(styles.settingsTabContainer)}>
      <HTMLElement
        aria-selected={isActiveTab}
        role={HTMLElement === 'button' ? 'tab' : 'link'}
        title="settings"
        className={classes}
        onClick={HTMLElement === 'button' ? () => props.onTabClicked(props.index) : null}
        data-test={props.dataTest}
      >
        <Icon icon="utility-settings" className={styles.settingsIcon} />
        <span>settings</span>
      </HTMLElement>
    </div>
  );
};
